<template>
  <div class="spotinfo"  v-bind:style="{ background: spotColor }">
    <div class="nav">
      <div class="logo"><img src="/assets/images/logo-navbar.svg"></div>
      <div class="button-home" @click="goSpots"><img src="/assets/buttons/button-home.svg"></div>
      <div class="button-close" @click="getThemes"><img src="/assets/buttons/button-close.svg"></div>
    </div>
    <div class="spotinfo-header">
      <div class="spotinfo-title">Introductie<br>{{ decodeURI(spotName) }}</div>
    </div>

    <div class="spotinfo-container">
      <img class="spotinfo-image" :src="spotImage">
      <div class="spotinfo-description">{{ decodeURI(spotDescription) }}</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import config from '@/config/config.json';
import configAPIFull from "@/config/api.json";
let configAPI = {};
if (config.istest) {
  configAPI = configAPIFull.test;
} else {
  configAPI = configAPIFull.production;
}

export default {
  name: "SpotInfo",
  props: ['langId', 'spotId'],
  data() {
    return {
      spotName: '',
      spotDescription: '',
      spotImage: '',
      spotColor: ''
    }
  },
  methods: {
    getThemes() {
      router.push('/'+this.spotId+'/themes/' + this.langId);
    },
    goSpots() {
      router.push('/spots/' + this.langId);
    }
  },
  created() {
    var spotData = {
      "code": "",
      "name": "",
      "description": "",
      "color": "#ff0000"
    };
    var axiosSpot = configAPI.url + 'spot/' + this.langId + '/' + this.spotId;
    axios.get(axiosSpot)
        .then((res) => {
          spotData = res.data;
          this.spotName = spotData.name;
          this.spotDescription = spotData.description;
          this.spotColor = spotData.color;
          this.spotImage = spotData.thumb;
        })
  }
}
</script>

<style>
.spotinfo {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  color: white;
  padding-bottom: 110px;
}
.spotinfo-header {
  position: relative;
  top: 75px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.spotinfo-title {
  font-family: EtelkaMedium;
  font-size: 1.4em;
  width: 100%;
}
.spotinfo-container {
  position: relative;
  top: 90px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.spotinfo-description {
  float: none;
  width: 100%;
  padding-top: 10px;
  font-family: EtelkaLight;
  color: white;
  font-size: 1em;
  clear: left;
}
.spotinfo-image {
  width: 100%;
  height: auto;
}
</style>
